import React from "react"
import { Popover } from "react-bootstrap"
import dayjs from "dayjs"
import EmployeeDataTypes from "src/pages/hr/Types/EmployeeTypes"
import DynamicFormReferenceTypes from "../Types/DynamicFormReferenceTypes"
import DynamicFormTaskTypes from "../Types/DynamicFormTaskTypes"
import TaskDynamicFormTypes from "../Types/TaskDynamicFormTypes"
import hashTable from "../Utils/hashTable"
import normalizeReferenceData from "../Utils/NormalizeReferenceData"
import taskDynamicFormBoiler from "../Utils/TaskDynamicFormBoiler"

type NormalizedDistributionGroupTypes =
    Array<{
        PortalDynamicFormDistributionGroupId: number,
        Name: string,
        ReferenceName: string,
        data: { normalized: Array<{ id: number, text: string, hashKey: string }>, orinalKeys: Array<string> } | any //!!!!!!
        allChecked: boolean
        CustomKey?: string
    }>

let distributionGroups: NormalizedDistributionGroupTypes = []
let pointAliases: Array<{ Name: string, alias: string }> = []
let reference: DynamicFormReferenceTypes = { ProfitCenters: [], States: [], Employees: [], DistributionPoints: [], DistributionGroups: [] }
const storageSize = 2500
const ht = new hashTable(storageSize)

const taskHelper = {
    init: (taskReference: DynamicFormReferenceTypes, employees: Array<EmployeeDataTypes>) => {
        reference = { ...taskReference, ...{ Employees: employees } }
        distributionGroups = [
            {
                PortalDynamicFormDistributionGroupId: 1,
                ReferenceName: "ProfitCenters",
                Name: "ProfitCenter",
                data: normalizeReferenceData.normalize(reference.ProfitCenters, ["profitCenterId", "profitCenterName"], "asc"),
                allChecked: false
            },
            {
                PortalDynamicFormDistributionGroupId: 2,
                ReferenceName: "Companies",
                Name: "Company",
                data: { normalized: [] },
                allChecked: false
            },
            {
                PortalDynamicFormDistributionGroupId: 3,
                ReferenceName: "Employees",
                Name: "Employee",
                //@ts-ignore
                data: normalizeReferenceData.normalize(reference.Employees, ["UserId", "DisplayName"]),
                CustomKey: "UserId",
                allChecked: false,
            },
            {
                PortalDynamicFormDistributionGroupId: 4,
                ReferenceName: "States",
                Name: "State",
                data: normalizeReferenceData.normalize(reference.States, ["StateId", "StateName"]),
                allChecked: false,
            }
        ]
        pointAliases = [
            {
                Name: "*",
                alias: "All"
            }
        ]
        taskHelper.buildhashTable()
    },
    buildhashTable: () => {
        for (let i = 0; i < distributionGroups.length; i++) {
            const group = distributionGroups[i]
            for (let j = 0; j < group.data.normalized.length; j++) {
                const hashKey = group.data.normalized[j].hashKey
                const data = {
                    location: j,
                    Value: `${group.data.normalized[j].id}`,
                    FormDistributeTo: group.Name,
                    ReferenceItem: group.ReferenceName,
                    DistributionPointName: group.data.normalized[j].text,
                    PortalDynamicFormDistributionGroupId: i + 1,
                    checked: false
                }
                ht.addItem([hashKey, ht.hash(hashKey, storageSize), data])
            }
        }
        return ht.getStorage()
    },
    lookupItem: (hashKey: string) => {
        return ht.lookupItem(hashKey)
    },
    getDistributionGroup: (text: string) => {
        return distributionGroups.filter(obj => {
            return obj.Name === text
        })[0]
    },
    getPointAlias: (text: string) => {
        const str = pointAliases.filter(obj => {
            return obj.Name === text
        })[0]
        return str ? str.alias : text
    },
    getTable: () => {
        return ht.getStorage()
    },
    update: (hashKey: string, args: any) => {
        ht.updateItem(hashKey, args)
    },
    isChecked: (hashKey: string) => {
        const checked = ht.lookupItem(hashKey)[2].checked
        return checked
    },
    checkOrUncheckAll: (groupName: string) => {
        //@ts-ignore
        const group = taskHelper.getDistributionGroup(groupName)
        const action = !group.allChecked
        distributionGroups[group.PortalDynamicFormDistributionGroupId - 1].allChecked = action
        for (let i = 0; i < group.data.normalized.length; i++) {
            let bucketItem = taskHelper.lookupItem(group.data.normalized[i].hashKey)
            bucketItem[2].checked = action
            taskHelper.update(bucketItem[0], { checked: action })
        }
    },
    getTasks: () => {
        let tasks: Array<DynamicFormTaskTypes> | any = []
        let checkedTally: any = {}
        for (let i = 0; i < distributionGroups.length; i++) {
            const group = distributionGroups[i]
            checkedTally[group.Name] = 0
            for (let j = 0; j < group.data.normalized.length; j++) {
                const hashKey = group.data.normalized[j].hashKey
                if (taskHelper.isChecked(hashKey)) {
                    const bucketItem = ht.lookupItem(hashKey)[2]
                    tasks.push(taskHelper.buildBaseTask(bucketItem))
                    checkedTally[group.Name]++
                }
            }
        }
        const obj = { taskList: tasks, checkedTally: checkedTally }
        return obj
    },
    buildBaseTask: (bucketItem: { Value: string, FormDistributeTo: string, DistributionPointName: string, PortalDynamicFormDistributionGroupId: number }) => {
        let task: TaskDynamicFormTypes = JSON.parse(JSON.stringify(taskDynamicFormBoiler))
        task.Value = bucketItem.Value
        task.FormDistributeTo = bucketItem.FormDistributeTo
        task.DistributionPointName = bucketItem.DistributionPointName
        task.PortalDynamicFormDistributionGroupId = bucketItem.PortalDynamicFormDistributionGroupId
        return task
    },
    buildFinalTasks: (userId: string | number, CustomFormId: number, boiler: TaskDynamicFormTypes) => {
        let tasks = taskHelper.getTasks().taskList
        for (let i = 0; i < tasks.length; i++) {
            tasks[i].CreatedBy = userId
            tasks[i].CustomFormId = CustomFormId
            //@ts-ignore
            tasks[i].DueDateUTC = dayjs(boiler.DueDateUTC).format()
            tasks[i].DistributionPoint = boiler.DistributionPoint
            tasks[i].PortalDynamicFormDistributionPointId = boiler.PortalDynamicFormDistributionPointId
        }
        return tasks
    },
    statusPopover: (missing: Array<String>) => {
        const show = missing.length > 0
        return (
            <Popover id={`task-dynamic-form-missing-fields-popover-${show ? "show" : "hide"}`}>
                <Popover.Title as="h2">Issues:</Popover.Title>
                {missing.map((item, index: number) =>
                    <div className="TaskDynamicFormMissingFieldsPopoverText" key={`missing-item-${index}`}>
                        {`${index + 1}. ${item}`}
                    </div>)}
            </Popover>
        )
    }
}

export default taskHelper